import { infos_to_display } from "../settings";

import useMeowLightboxContext from "../context";
import { useController } from "../helpers";
import { Description } from "./Description";
import { ExifComponent } from "./ExifComponent";
import { Title } from "./Title";

export const MeowLightboxMetadata = ({ className }) => {
  const { onCloseClick } = useController();
  const { image } = useMeowLightboxContext();

  const exifs = [
    {
      name: 'Camera',
      icon: 'camera',
      value: image?.exifs?.camera,
      visible: image?.exifs?.camera !== "N/A" && infos_to_display.camera,
    },
    {
      name: 'Lens',
      icon: 'lens',
      value: image?.exifs?.lens,
      visible: image?.exifs?.lens !== "N/A" && infos_to_display.lens,
    },
    {
      name: 'FocalLength',
      icon: 'eye',
      value: image?.exifs?.focal_length,
      visible: image?.exifs?.focal_length !== "N/A" && infos_to_display.focal_length,
    },
    {
      name: 'ShutterSpeed',
      icon: 'shutter_speed',
      value: image?.exifs?.shutter_speed,
      visible: image?.exifs?.shutter_speed !== "N/A" && infos_to_display.shutter_speed,
    },
    {
      name: 'Aperture',
      icon: 'aperture',
      value: image?.exifs?.aperture,
      visible: image?.exifs?.aperture !== "N/A" && infos_to_display.aperture,
    },
    {
      name: 'Iso',
      icon: 'iso',
      value: image?.exifs?.iso,
      visible: image?.exifs?.iso !== "N/A" && infos_to_display.iso,
    },
    {
      name: 'Date',
      icon: 'calendar',
      value: image?.exifs?.date,
      visible: image?.exifs?.date !== "N/A" && image?.exifs?.date != 0 && infos_to_display.date,
    },
    {
      name: 'Keywords',
      icon: 'sharing',
      value: image?.exifs?.keywords,
      visible: image?.exifs?.keywords !== "N/A" && infos_to_display.keywords,
    }
  ];

  if (!image) {
    return null;
  }

  return (
    <div className={className}>
      <Title image={image} />
      <Description image={image} />

      <div className="exifs" onClick={onCloseClick}>
        {exifs.filter(v => v.visible).map(v => <ExifComponent {...v} />)}
      </div>
    </div>
  );
};
